import React from "react";
import { TableRow, TableCell } from "@mui/material";
import CeldaMotivoContinuidad from "./cells/CeldaMotivoContinuidad";
import CeldaCedula from "./cells/CeldaCedula";
import CeldaAlmacen from "./cells/CeldaAlmacen";
import CeldaEstado from "./cells/CeldaEstado";
import CeldaEntregaProducto from "./cells/CeldaEntregaProducto";
import CeldaResultado from "./cells/CeldaResultado";
import CeldaDetalles from "./cells/CeldaDetalles";
import CeldaIdentificador from "./cells/CeldaIdentificador";
import CeldaDigital from "./cells/CeldaDigital";
import CeldaInfo from "./cells/CeldaInfo";
import CeldaSolicitudes from "./cells/CeldaSolicitudes";
import CeldaDocumental from "./cells/CeldaDocumental";
import CeldaTelefonica from "./cells/CeldaTelefonica";
import CeldaDomicilio from "./cells/CeldaDomicilio";
import CeldaLaboral from "./cells/CeldaLaboral";
import CeldaAnalista from "./cells/CeldaAnalista";
import CeldaOperador from "./cells/CeldaOperador";
import CeldaInformeOperador from "./cells/CeldaInformeOperador";

// Una fila de la tabla de ListadoSolicitud.js. Cada celda compleja vive en su
// propio componente bajo ./cells/ (mismo JSX y lógica que tenía aquí mismo
// antes de dividirse, solo reubicado); las celdas triviales de una sola línea
// (N° Solicitud, Cliente, Fecha, Vendedor, Tipo de Cliente) se quedan inline.
export default function SolicitudTableRow({
  data,
  index,
  analistas,
  operadores,
  popoverData,
  clienteEstados,
  setIsOpenMotivo,
  setDataInforme,
  setCurrentAction,
  setCurrentData,
  setOpenDialog2,
  setIsOpenPdf,
  handleOpenObservacionCredito,
  handlePopoverOpen,
  handlePopoverClose,
  handleOpenCambioBodega,
  handleOpenDialog,
  handleOpenFirmaElectronica,
  handleOpenAuditoriaIntegral,
  handlesolicitud,
  handledocumentos,
  handleTelefonica,
  handleOpenModalVerificacion,
  handleOpenDialogDomicilioLaboral,
  handleEditarAnalista,
  handleEditarOperador,
  permisosFila,
  estaDeshabilitado,
  verificacionSolicitud,
}) {
  const {
    permisoAgregarObservacionCredito,
    permisoCambiarBodega,
    permisoAprobarEstado,
    tienePermisoEditarAnalista,
    permisoEditarOperador,
    estadoDeshabilitadoporPermisos,
    estadoDeshabilitadoDocumental,
    estadoDeshabilitadotelefonica,
    permisoEditarVerificacionTerreno,
    permisoReasignarDomicilio,
    permisoReasignarLaboral,
  } = permisosFila;

  const puedeFirmar =
    data.TipoFirmaElectronica === 1 &&
    data.Estado === 6 &&
    data.idEstadoVerificacionDocumental === 4 &&
    data.idEstadoVerificacionSolicitud === 12;
  const isError = (data.Estado === 4 || data.Estado === 5 || data.Estado === 7);
  const isReprocesoRow = data.Estado === 10;
  const bgColor = isError
    ? "#fee2e2"
    : isReprocesoRow
      ? "#ffedd5"
      : index % 2 === 0
        ? "#f9fafb"
        : "#ffffff";
  const textColor = isError ? "#991b1b" : isReprocesoRow ? "#9a3412" : "#1f2937";
  return (
    <TableRow
      sx={{
        backgroundColor: bgColor,
        transition: "all 0.25s ease-in-out",
        "&:hover": {
          backgroundColor: isError ? "#fecaca" : isReprocesoRow ? "#fed7aa" : "#f1f5f9",
          boxShadow: "0 8px 15px rgba(0,0,0,0.12)",
          transform: "translateY(-4px)",
        },
        "&:active": {
          transform: "translateY(-2px)",
          boxShadow: "0 4px 8px rgba(0,0,0,0.08)",
        },
        // Definimos bordes para todas las celdas
        "& td": {
          border: "1px solid",
          borderColor: isError ? "#fecaca" : isReprocesoRow ? "#fed7aa" : "#e5e7eb",
          padding: "14px 8px",
          fontSize: "0.875rem",
          color: textColor,
          transition: "all 0.25s ease-in-out",
        },
        // Aplicar esquinas redondeadas a primera y última celda
        "& td:first-of-type": {
          borderRadius: "8px 0 0 8px",
          borderRight: "none",
        },
        "& td:last-of-type": {
          borderRadius: "0 8px 8px 0",
          borderLeft: "none",
        },
        // Para celdas intermedias, eliminamos bordes laterales duplicados
        "& td:not(:first-of-type):not(:last-of-type)": {
          borderLeft: "none",
          borderRight: "none",
        },
        boxShadow: "0 1px 3px rgba(0,0,0,0.03)",
        cursor: "pointer",
      }}
    >
      <CeldaMotivoContinuidad
        data={data}
        setIsOpenMotivo={setIsOpenMotivo}
        setDataInforme={setDataInforme}
      />

      <TableCell align="center">
        {data.NumeroSolicitud}
      </TableCell>
      <TableCell align="center">{data.nombre}</TableCell>

      <CeldaCedula
        data={data}
        permisoAgregarObservacionCredito={permisoAgregarObservacionCredito}
        handleOpenObservacionCredito={handleOpenObservacionCredito}
        handlePopoverOpen={handlePopoverOpen}
        popoverData={popoverData}
        handlePopoverClose={handlePopoverClose}
        clienteEstados={clienteEstados}
      />

      <TableCell align="center">
        {new Date(data.fecha).toLocaleString()}
      </TableCell>

      <CeldaAlmacen
        data={data}
        permisoCambiarBodega={permisoCambiarBodega}
        handleOpenCambioBodega={handleOpenCambioBodega}
      />

      <TableCell align="center">{data.vendedor}</TableCell>

      <CeldaEstado
        data={data}
        permisoAprobarEstado={permisoAprobarEstado}
        setCurrentAction={setCurrentAction}
        setCurrentData={setCurrentData}
        setOpenDialog2={setOpenDialog2}
        handlePopoverOpen={handlePopoverOpen}
      />

      <CeldaEntregaProducto data={data} />

      {/* Tipo de Cliente */}
      <TableCell align="center">{data.tipoCliente}</TableCell>

      <CeldaResultado data={data} handlePopoverOpen={handlePopoverOpen} />

      <CeldaDetalles data={data} isError={isError} handleOpenDialog={handleOpenDialog} />

      <CeldaIdentificador data={data} />

      <CeldaDigital
        data={data}
        puedeFirmar={puedeFirmar}
        handleOpenFirmaElectronica={handleOpenFirmaElectronica}
        handlePopoverOpen={handlePopoverOpen}
      />

      <CeldaInfo data={data} isError={isError} handleOpenAuditoriaIntegral={handleOpenAuditoriaIntegral} />

      <CeldaSolicitudes
        data={data}
        isError={isError}
        estaDeshabilitado={estaDeshabilitado}
        estadoDeshabilitadoporPermisos={estadoDeshabilitadoporPermisos}
        handlesolicitud={handlesolicitud}
        handlePopoverOpen={handlePopoverOpen}
      />

      <CeldaDocumental
        data={data}
        isError={isError}
        estaDeshabilitado={estaDeshabilitado}
        estadoDeshabilitadoDocumental={estadoDeshabilitadoDocumental}
        verificacionSolicitud={verificacionSolicitud}
        handledocumentos={handledocumentos}
        handlePopoverOpen={handlePopoverOpen}
      />

      <CeldaTelefonica
        data={data}
        isError={isError}
        estaDeshabilitado={estaDeshabilitado}
        verificacionSolicitud={verificacionSolicitud}
        estadoDeshabilitadotelefonica={estadoDeshabilitadotelefonica}
        handleTelefonica={handleTelefonica}
        handlePopoverOpen={handlePopoverOpen}
      />

      <CeldaDomicilio
        data={data}
        isError={isError}
        verificacionSolicitud={verificacionSolicitud}
        permisoEditarVerificacionTerreno={permisoEditarVerificacionTerreno}
        permisoReasignarDomicilio={permisoReasignarDomicilio}
        handleOpenModalVerificacion={handleOpenModalVerificacion}
        handleOpenDialogDomicilioLaboral={handleOpenDialogDomicilioLaboral}
        handlePopoverOpen={handlePopoverOpen}
      />

      <CeldaLaboral
        data={data}
        isError={isError}
        verificacionSolicitud={verificacionSolicitud}
        permisoEditarVerificacionTerreno={permisoEditarVerificacionTerreno}
        permisoReasignarLaboral={permisoReasignarLaboral}
        handleOpenModalVerificacion={handleOpenModalVerificacion}
        handleOpenDialogDomicilioLaboral={handleOpenDialogDomicilioLaboral}
        handlePopoverOpen={handlePopoverOpen}
      />

      <CeldaAnalista
        data={data}
        analistas={analistas}
        tienePermisoEditarAnalista={tienePermisoEditarAnalista}
        handleEditarAnalista={handleEditarAnalista}
        handlePopoverOpen={handlePopoverOpen}
      />

      <CeldaOperador
        data={data}
        operadores={operadores}
        permisoEditarOperador={permisoEditarOperador}
        handleEditarOperador={handleEditarOperador}
        handlePopoverOpen={handlePopoverOpen}
      />

      <CeldaInformeOperador data={data} setIsOpenPdf={setIsOpenPdf} setDataInforme={setDataInforme} />
    </TableRow>
  );
}
